import React from 'react'
import HeroImage from '../components/HeroImage'
import CourseList from '../components/CourseList'
import Footer from '../components/Footer'
import { Box, SlideFade, Text, VStack } from '@chakra-ui/react'
import Quote from '../components/Quote'

import ballet8 from '../assets/course8.jpg'
import moderny from '../assets/moderny.jpg'
import stretching from '../assets/stretching.jpg'
import { useTranslation } from 'react-i18next'

const courses = [
  {
    title: 'courses.classicChildren',
    subTitle: 'courses.ages24, courses.ages58, courses.ages9',
    image: ballet8,
    href: '/ballet'
  },
  {
    title: 'courses.modernChildren',
    subTitle: 'courses.beginners, courses.advanced',
    image: moderny,
    href: '/modern'
  },
  {
    title: 'courses.stretching',
    subTitle: 'courses.adults',
    image: stretching,
    href: '/stretching'
  },
]

const HomePage = () => {
  const { t } = useTranslation()
  const translatedCourses = courses.map((course) => ({
    ...course,
    title: t(course.title),
    subTitle: course.subTitle.split(', ').map((key) => t(key)).join(', '),
  }))

  return (
    <SlideFade in={true} offsetY='-20px'>
      <HeroImage />
      <Box bg={'#f5f5f7'} padding={{ base: '4vh 5vw 8vh', md: '5vh 5vw 10vh' }}>
        <VStack
          width={'100%'}
          maxW={'1180px'}
          margin={'auto'}
          spacing={{ base: 8, md: 12 }}>
          <Text
            fontSize={{ base: '3xl', md: '4xl' }}
            fontFamily={'heading'}
            fontWeight={'bold'}
            letterSpacing={'-0.03em'}
            textAlign={'center'}>
            {t('home.checkCourses')}
          </Text>
          <CourseList courses={translatedCourses}/>
          <Quote>
            "Inchilza is an award winning dance school in Sofia. We offer an international approach to ballet and contemporary dance. "
          </Quote>
        </VStack>
      </Box>
      <Footer />
    </SlideFade>
  )
}

export default HomePage
